"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _data = require("../config/data");

var _classnames = _interopRequireDefault(require("classnames"));

var _classname_map = _interopRequireDefault(require("../config/classname_map"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ShortcutItemComponent = function ShortcutItemComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onClick = props.onClick,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label;
  return _react["default"].createElement("li", null, _react["default"].createElement("a", {
    className: "spaui-cursor-pointer",
    onClick: onClick
  }, label));
};
/**
 * @class
 */


var ShourtCutPanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ShourtCutPanel, _PureComponent);

  function ShourtCutPanel(props) {
    var _this;

    _classCallCheck(this, ShourtCutPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShourtCutPanel).call(this, props));
    _this.handleRangeClick = _this.handleRangeClick.bind(_assertThisInitialized(_this));
    _this.handleSingleClick = _this.handleSingleClick.bind(_assertThisInitialized(_this));
    return _this;
  } // 初始化相关的time


  _createClass(ShourtCutPanel, [{
    key: "getTimeInfo",
    value: function getTimeInfo() {
      var _this$props = this.props,
          optionalStartDateData = _this$props.optionalStartDateData,
          optionalEndDateData = _this$props.optionalEndDateData;

      var formatOptionalDate = function formatOptionalDate(optionalDate) {
        var year = optionalDate.year,
            month = optionalDate.month,
            date = optionalDate.date,
            _optionalDate$hour = optionalDate.hour,
            hour = _optionalDate$hour === void 0 ? 0 : _optionalDate$hour,
            _optionalDate$minute = optionalDate.minute,
            minute = _optionalDate$minute === void 0 ? 0 : _optionalDate$minute,
            _optionalDate$second = optionalDate.second,
            second = _optionalDate$second === void 0 ? 0 : _optionalDate$second;
        return new Date(year, month, date, hour, minute, second).getTime();
      };

      var optionalStartDateTime = formatOptionalDate(optionalStartDateData);
      var optionalEndDateTime = formatOptionalDate(optionalEndDateData);
      return {
        optionalStartDateTime: optionalStartDateTime,
        optionalEndDateTime: optionalEndDateTime
      };
    } // 获取不可点击天数

  }, {
    key: "getDisableWeekDays",
    value: function getDisableWeekDays() {
      var dom = document.querySelectorAll(".".concat(_classname_map["default"].DatePickerDateItemDisabledClassName));
      var result = [];
      dom.forEach(function (item) {
        if (item.childNodes[0]) {
          var child = item.childNodes[0].childNodes;

          if (child.length > 1) {
            result.push(child[0].textContent);
          }
        }
      });
      return result;
    } // 点击日期范围的快捷选择

  }, {
    key: "handleRangeClick",
    value: function handleRangeClick(event, theStartDate, theEndDate, shortcutData) {
      var _this2 = this;

      var _this$props2 = this.props,
          picker = _this$props2.picker,
          onChange = _this$props2.onChange,
          optionalStartDateData = _this$props2.optionalStartDateData,
          optionalEndDateData = _this$props2.optionalEndDateData,
          unlimitedDateValue = _this$props2.unlimitedDateValue,
          firstDayOfWeek = _this$props2.firstDayOfWeek,
          endDayOfWeek = _this$props2.endDayOfWeek,
          _this$props2$shortcut = _this$props2.shortcutsConfig,
          shortcutsConfig = _this$props2$shortcut === void 0 ? {} : _this$props2$shortcut,
          format = _this$props2.format,
          maxHour = _this$props2.maxHour;

      var _this$getTimeInfo = this.getTimeInfo(),
          optionalStartDateTime = _this$getTimeInfo.optionalStartDateTime,
          optionalEndDateTime = _this$getTimeInfo.optionalEndDateTime;

      var _shortcutsConfig$limi = shortcutsConfig.limitOptionalStartTime,
          limitOptionalStartTime = _shortcutsConfig$limi === void 0 ? true : _shortcutsConfig$limi,
          _shortcutsConfig$limi2 = shortcutsConfig.limitOptionalEndTime,
          limitOptionalEndTime = _shortcutsConfig$limi2 === void 0 ? true : _shortcutsConfig$limi2,
          _shortcutsConfig$useS = shortcutsConfig.useShortcutDate,
          useShortcutDate = _shortcutsConfig$useS === void 0 ? false : _shortcutsConfig$useS;

      var getDateOfAcquisition = function getDateOfAcquisition(theDate) {
        var result = {};

        if (_typeof(theDate) === 'object') {
          if (theDate.getTime() < optionalStartDateTime && limitOptionalStartTime) {
            result = optionalStartDateData;
          } else if (theDate.getTime() > optionalEndDateTime && limitOptionalEndTime) {
            result = optionalEndDateData;
          } else {
            result = {
              year: theDate.getFullYear(),
              month: theDate.getMonth(),
              date: theDate.getDate(),
              hour: theDate.getHours() || 0,
              minute: theDate.getMinutes() || 0,
              second: theDate.getSeconds() || 0
            };

            if (picker === 'week') {
              result.disableWeekDays = (0, _utils.getHideWeekDays)(theStartDate, theEndDate, firstDayOfWeek, endDayOfWeek).concat(_this2.getDisableWeekDays());
            }
          }
        } else if (theDate === unlimitedDateValue) {
          // 如果是无限日期那就直接返回
          result = theDate;
        }

        return result;
      };

      if ((0, _spauiUtils.isFunction)(onChange)) {
        if (useShortcutDate) {
          onChange(event, (0, _spauiUtils.splitDate)(shortcutData.startDate, format, {
            maxHour: maxHour
          }), (0, _spauiUtils.splitDate)(shortcutData.endDate, format, {
            maxHour: maxHour
          }));
        } else {
          onChange(event, getDateOfAcquisition(theStartDate), getDateOfAcquisition(theEndDate));
        }
      }
    } // 点击单个日期的快捷选择

  }, {
    key: "handleSingleClick",
    value: function handleSingleClick(event, theDate, shortcutData) {
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          _this$props3$shortcut = _this$props3.shortcutsConfig,
          shortcutsConfig = _this$props3$shortcut === void 0 ? {} : _this$props3$shortcut,
          format = _this$props3.format,
          maxHour = _this$props3.maxHour;
      var _shortcutsConfig$useS2 = shortcutsConfig.useShortcutDate,
          useShortcutDate = _shortcutsConfig$useS2 === void 0 ? false : _shortcutsConfig$useS2;

      var _this$getTimeInfo2 = this.getTimeInfo(),
          optionalStartDateTime = _this$getTimeInfo2.optionalStartDateTime,
          optionalEndDateTime = _this$getTimeInfo2.optionalEndDateTime; // 在可选日期内才响应


      if (useShortcutDate) {
        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, (0, _spauiUtils.splitDate)(shortcutData.date, format, {
            maxHour: maxHour
          }));
        }
      } else {
        if ((0, _spauiUtils.isFunction)(onChange) && theDate.getTime() >= optionalStartDateTime && theDate.getTime() <= optionalEndDateTime) {
          onChange(event, {
            year: theDate.getFullYear(),
            month: theDate.getMonth(),
            date: theDate.getDate()
          });
        }
      }
    } // 获取今天的日期

  }, {
    key: "getToday",
    value: function getToday() {
      var _this$props4 = this.props,
          nowDateObject = _this$props4.nowDateObject,
          startData = _this$props4.startData;
      var useDynamicDate = this.useDynamicDate();
      var dateObject = nowDateObject;

      if (useDynamicDate) {
        dateObject = new Date(startData.year, startData.month, startData.date);
      }

      return new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate());
    } // 根据相对月份获取具体日期

  }, {
    key: "getDateByRelativeMonth",
    value: function getDateByRelativeMonth() {
      var dateType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var relativeMonth = arguments.length > 1 ? arguments[1] : undefined;
      var today = this.getToday();
      var theYear = 0;
      var theMonth = 0;
      var theDate = 0;
      theYear = today.getFullYear();
      theMonth = today.getMonth();

      if (relativeMonth > 0) {
        theMonth += relativeMonth;

        if (theMonth > 11) {
          theMonth = theMonth % 12;
          theYear = Math.floor(theMonth / 12) + theYear;
        }
      } else {
        theYear = theYear + Math.ceil(relativeMonth / 12);
        theMonth = theMonth + relativeMonth % 12;

        if (theMonth < 0) {
          theYear = theYear - 1;
          theMonth = 12 + theMonth;
        }
      } // 如果是结束日期的话，日期为最后一天


      if (dateType === 'end') {
        theDate = new Date(theYear, theMonth + 1, 0).getDate();
      } else {
        theDate = 1;
      }

      return new Date(theYear, theMonth, theDate);
    } // 获取对应的日期

  }, {
    key: "getDate",
    value: function getDate(dateType, absoluteDate, relativeDate, relativeMonth, relativeSecond) {
      var today = this.getToday();
      var result = null;

      if (absoluteDate) {
        result = new Date(absoluteDate);
      } else if (!(0, _spauiUtils.isUndefined)(relativeDate)) {
        result = new Date(today.getTime() + relativeDate * _data.ONE_DAY_TIME);
      } else if (!(0, _spauiUtils.isUndefined)(relativeMonth)) {
        result = this.getDateByRelativeMonth(dateType, relativeMonth);
      } else if (!(0, _spauiUtils.isUndefined)(relativeSecond)) {
        result = new Date(new Date().getTime() + relativeSecond * 1000);
      }

      return result;
    }
  }, {
    key: "useDynamicDate",
    value: function useDynamicDate() {
      var _this$props5 = this.props,
          shortcuts = _this$props5.shortcuts,
          type = _this$props5.type,
          startData = _this$props5.startData,
          endData = _this$props5.endData;
      var result = false;

      if ((0, _spauiUtils.isArray)(shortcuts) && type === 'range' && startData.year && !endData.year) {
        shortcuts.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (item.dynamicDate) {
            result = true;
          }

          return item;
        });
      }

      return result;
    }
  }, {
    key: "getShortcuts",
    value: function getShortcuts() {
      var _this$props6 = this.props,
          shortcuts = _this$props6.shortcuts,
          useNewUI = _this$props6.useNewUI;
      var result = [];

      if ((0, _spauiUtils.isArray)(shortcuts)) {
        if (this.useDynamicDate()) {
          shortcuts.map(function () {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (item.dynamicDate) {
              result.push(item);
            }

            return item;
          });
        } else {
          shortcuts.map(function () {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!item.dynamicDate) {
              result.push(item);
            }

            return item;
          });
        } // 新版 UI 支持指定哪些快捷日期显示在顶部或者底部 (默认全部显示在顶部)


        if (useNewUI) {
          var topShortcuts = result.filter(function (item) {
            return item.position === 'top' || typeof item.position === 'undefined';
          });
          var bottomShortcuts = result.filter(function (item) {
            return item.position === 'bottom';
          });
          result = [topShortcuts, bottomShortcuts];
        }
      } else {
        result = shortcuts;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props7 = this.props,
          type = _this$props7.type,
          unlimitedDateValue = _this$props7.unlimitedDateValue,
          startDateCanBeUnlimited = _this$props7.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _this$props7.endDateCanBeUnlimited,
          startData = _this$props7.startData,
          getDateValue = _this$props7.getDateValue,
          format = _this$props7.format,
          endData = _this$props7.endData,
          _this$props7$classNam = _this$props7.classNameMap,
          classNameMap = _this$props7$classNam === void 0 ? {} : _this$props7$classNam,
          useNewUI = _this$props7.useNewUI;
      var shortcuts = this.getShortcuts(); // 如果不是有数据的数组为空

      if (!(0, _spauiUtils.isArray)(shortcuts) || shortcuts.length < 1) {
        return null;
      } // 生成快捷日期选项


      var genShortcutsItem = function genShortcutsItem() {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;

        if (type === 'range' && item.label) {
          var startDateIsUnlimited = (item.startDate || typeof item.startDate === 'number') && item.startDate === unlimitedDateValue;
          var endDateIsUnlimited = (item.endDate || typeof item.endDate === 'number') && item.endDate === unlimitedDateValue;
          var startDate = startDateIsUnlimited && startDateCanBeUnlimited ? item.startDate : _this3.getDate('', item.startDate, item.startRelativeDate, item.startRelativeMonth, item.startRelativeSecond);
          var endDate = endDateIsUnlimited && endDateCanBeUnlimited ? item.endDate : _this3.getDate('end', item.endDate, item.endRelativeDate, item.endRelativeMonth, item.endRelativeSecond); // 设置了无限日期，但是又没有开启，那就不展示该快捷日期

          if (startDateIsUnlimited && !startDateCanBeUnlimited || endDateIsUnlimited && !endDateCanBeUnlimited) {
            return null;
          } // 如果开始日期可以是无限的，当日期是无限的时候，快捷选择的第二个日期如果是动态的，那就隐藏掉


          if (startDateCanBeUnlimited && !endData.year && typeof item.endRelativeDate !== 'undefined' && (0, _spauiUtils.joinDate)(startData, format) === getDateValue('startDate', unlimitedDateValue)) {
            return null;
          }

          if (endDate && endDate.setHours && endDate.setMinutes && endDate.setSeconds && typeof item.endRelativeSecond === 'undefined') {
            // endDate设置为当天的23:59:59
            endDate = new Date(endDate.setHours(23));
            endDate = new Date(endDate.setMinutes(59));
            endDate = new Date(endDate.setSeconds(59));
          }

          if (startDate && endDate) {
            return _react["default"].createElement(ShortcutItemComponent, {
              key: index,
              onClick: function onClick(event) {
                return _this3.handleRangeClick(event, startDate, endDate, item);
              },
              label: item.label
            });
          }

          return null;
        }

        if (type === 'single' && item.label) {
          var date = _this3.getDate('', item.date, item.relativeDate, item.relativeMonth);

          if (date) {
            return _react["default"].createElement(ShortcutItemComponent, {
              key: index,
              onClick: function onClick(event) {
                return _this3.handleSingleClick(event, date, item);
              },
              label: item.label
            });
          }

          return null;
        }

        return null;
      };

      if (useNewUI) {
        var _classNames, _classNames2;

        return _react["default"].createElement(_react["default"].Fragment, null, (0, _spauiUtils.isArray)(shortcuts[0]) && shortcuts[0].length > 0 ? _react["default"].createElement("ul", {
          className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerFastControlListClassName, true), _defineProperty(_classNames, classNameMap.DatePickerTopFastControlClassName, true), _classNames))
        }, shortcuts[0].map(genShortcutsItem)) : null, (0, _spauiUtils.isArray)(shortcuts[1]) && shortcuts[1].length > 0 ? _react["default"].createElement("ul", {
          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, classNameMap.DatePickerFastControlListClassName, true), _defineProperty(_classNames2, classNameMap.DatePickerBottomFastControlClassName, true), _classNames2))
        }, shortcuts[1].map(genShortcutsItem)) : null);
      }

      return _react["default"].createElement("ul", {
        className: classNameMap.DatePickerFastControlListClassName
      }, shortcuts.map(genShortcutsItem));
    }
  }]);

  return ShourtCutPanel;
}(_react.PureComponent);

_defineProperty(ShourtCutPanel, "propTypes", {
  shortcuts: _spauiUtils.PropTypes.array
});

var _default = ShourtCutPanel;
exports["default"] = _default;